import React, { useMemo } from "react";
import { BulkGroupUsersSummaryRecord } from "models/view-models/groups/bulk-group-users-summary-record";
import "./add-bulk-group-users-summary.scss";
import { t } from "utilities/localization/t";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface AddBulkGroupUsersSummaryProps {
    bulkGroupUsersRecord: BulkGroupUsersSummaryRecord;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constant
// ------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME: string = "add-bulk-group-users-summary";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const AddBulkGroupUsersSummary: React.FC<AddBulkGroupUsersSummaryProps> = ({
    bulkGroupUsersRecord,
}) => {
    const summaryDetails = useMemo(
        () => bulkGroupUsersRecord.getSummaryDetails(),
        [bulkGroupUsersRecord]
    );

    return (
        <div>
            <h6 className={`${CSS_CLASS_NAME}__summary-title`}>
                {t("bulkGroupUsersImportSummaryColon")}
            </h6>
            <div className={`${CSS_CLASS_NAME}__summary-item-list`}>
                {bulkGroupUsersRecord &&
                    summaryDetails.map((details) => (
                        <div className={`${CSS_CLASS_NAME}__summary-item`} key={details.name}>
                            <div className={`${CSS_CLASS_NAME}__summary-name`}>{details.name}</div>
                            <div className={`${CSS_CLASS_NAME}__summary-value`}>
                                {details.value}
                            </div>
                            <div className={`${CSS_CLASS_NAME}__summary-description`}>
                                {details.description}
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { AddBulkGroupUsersSummary };

// #endregion Exports
